import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { flyInOut } from '../../utility/animation/animations';

@Component({
   selector: 'samweb-calling-toast-dialog',
   templateUrl: './calling-toast-dialog.component.html',
   styleUrls: ['./calling-toast-dialog.component.scss'],
   animations: [flyInOut],
})
export class CallingToastDialogComponent implements OnInit {
   @Input()
   public stateValue: string;

   @Input()
   public leftIconDisabled: boolean;

   @Input()
   public rightIconDisabled: boolean;

   @Input()
   public samWiggle: boolean;

   @Input()
   public leftIcon: IconDefinition;

   @Input()
   public rightIcon: IconDefinition;

   @Input()
   public progressBar: boolean;

   @Output()
   public leftButtonClick = new EventEmitter();

   @Output()
   public rightButtonClick = new EventEmitter();

   constructor() {}

   ngOnInit(): void {}

   onLeftButtonClick() {
      this.leftButtonClick.emit();
   }

   onRightButtonClick() {
      this.rightButtonClick.emit();
   }
}
